<template>
  <div
    :class="`formulate-input-element formulate-input-element--${context.type} ${hasRequiredError}`"
    :data-type="context.type"
    @click="handleOpenModal"
  >
    <div
      class="mc-input d-inline-flex"
      :class="{
        'input-md': size == 'md',
        'input-sm': size == 'sm',
        __disabled: disabled,
        __multiple: hasSelected,
      }"
    >
      <!-- This input field is only used to show placeholder using regular input style -->
      <!-- If no value is selected -->
      <input
        v-if="!hasSelected"
        :placeholder="attrs.placeholder || context.label"
        style="border: 0; width: 200px"
        readonly
      />
      <div v-else-if="multiple" class="d-flex gap-2 flex-wrap">
        <template v-for="(value, index) in tagValue">
          <div
            v-b-tooltip.hover="value.length > 25 ? value : null"
            :class="value === attrs.disabledItem ? '__tag-disabled' : '__tag'"
          >
            <span>{{ value.length > 25 ? value.slice(0, 22) + '...' : value }}</span>
            <!-- temporary disabled remove button -->
            <!-- <i @click.stop="handleRemoveTag(value)" class="icon-outline_close" /> -->
          </div>
        </template>
        <div v-if="otherTagsTotal > 0" class="__count">
          <i class="icon-fill_plus" />
          <span>{{ otherTagsTotal }}</span>
        </div>
      </div>
      <div v-else-if="localFullObject?.[displayedBy]">
        {{ localFullObject[displayedBy] }}
      </div>
      <div v-else>{{ context.model }}</div>

      <i class="icon-fill_menu d-flex align-items-center" />
    </div>

    <ModalValueHelp
      :context="context"
      :attrs="attrs"
      :multiple="multiple"
      :fullObject="localFullObject"
      @update:fullObject="onUpdate"
    >
      <template v-for="(val, key) in slotFields" #[val.name]="{ item }">
        <!-- eslint-disable-next-line vue/require-component-is -->
        <component :is="val.slotComponent" :key="'slot-' + key" :item="item" />
      </template>
    </ModalValueHelp>
  </div>
</template>

<script>
import ModalValueHelp from './components/ModalValueHelp'
import isEmpty from 'lodash/isEmpty'

export default {
  components: {
    ModalValueHelp,
  },
  props: {
    context: {
      type: Object,
      required: true,
    },

    size: {
      type: String,
      default: 'md',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    displayedBy: {
      type: String,
    },

    fullObject: {},
  },
  emits: ['update:fullObject'],
  data() {
    return {
      localFullObject: {},
    }
  },
  computed: {
    // Shorthand for accessing context attributes
    attrs() {
      return this.context.attributes
    },

    slotFields() {
      return this.attrs?.tableFields ? this.attrs.tableFields.filter((v) => v.isSlot) : []
    },

    // add classes if it has validation error
    hasRequiredError() {
      if (this.context.visibleValidationErrors.includes('Wajib diisi'))
        return 'formulate-input-error__required'
      return ''
    },

    // if there is selected value(s)
    hasSelected() {
      if (this.attrs.hasDisabledItem) return true
      if (this.multiple) return this.context.model.length !== 0
      return this.context.model !== ''
    },

    otherTagsTotal() {
      const selectedTagCount = this.visibleTagCount - Number(Boolean(this.attrs.hasDisabledItem))

      const selectedValues = Array.isArray(this.context.model)
        ? this.context.model
        : [this.context.model]
      const otherTags =
        selectedValues.filter((value) => value !== null && value !== undefined && value !== '')
          .length - selectedTagCount
      return otherTags > 0 ? otherTags : 0
    },

    visibleTagCount() {
      const count = Number(this.attrs.visibleTagCount)
      return Number.isInteger(count) && count > 0 ? count : 2
    },

    selectedTagValues() {
      let objects = this.localFullObject || this.context.model
      if (!Array.isArray(objects)) objects = [objects]
      return objects
        .filter((item) => !!item)
        .map((item) => item[this.displayedBy])
        .filter((value) => value !== null && value !== undefined && value !== '')
    },

    tagValue() {
      const value = [...this.selectedTagValues]
      if (this.attrs.hasDisabledItem) {
        value.unshift(this.attrs.disabledItem)
      }
      return value.slice(0, this.visibleTagCount)
    },
  },
  watch: {
    fullObject: {
      handler(val) {
        this.localFullObject = this.multiple ? [...val] : { ...val }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    isEmpty,
    onUpdate($event) {
      this.localFullObject = this.multiple ? [...$event] : { ...$event }
      this.$emit('update:fullObject', $event)
    },
    handleOpenModal() {
      if (this.disabled) return
      this.$bvModal.show(`${this.attrs.name}-modal-value-help`)
    },
    handleRemoveTag(value) {
      if (!this.multiple || !Array.isArray(this.fullObject)) return

      const clickedTagIdx = this.context.model.findIndex((v) => v == value[this.attrs.trackBy])
      if (clickedTagIdx === -1) return

      const values = [...this.context.model]
      const localFullObject = Object.values(this.localFullObject)

      values.splice(clickedTagIdx, 1)
      localFullObject.splice(clickedTagIdx, 1)
      // eslint-disable-next-line vue/no-mutating-props
      this.context.model = values

      this.localFullObject = localFullObject
      this.$emit('update:fullObject', localFullObject)
    },
  },
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
